import React from 'react';
import EventBusyIcon from '@material-ui/icons/EventBusy';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        maxWidth: '32rem',
        gap: '1rem',
    },
    icon: {
        fontSize: '6rem',
    },
    title: {
        fontSize: '34px',
        fontWeight: 'bold',
    },
    text: {
        fontSize: '20px',
        marginBottom: '0.5rem',
    },
}));

const NoDataFound = ({
    title = 'ไม่สามารถเข้าร่วมประชุมได้',
    description = 'เนื่องจากไม่พบข้อมูลการประชุม หรือการประชุมจบลงแล้ว กรุณาติดต่อเจ้าหน้าที่ผู้จัดการประชุมเพื่อสอบถามรายละเอียดเพิ่มเติม',
    iconColor = '#f44336',
}) => {
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <div className={classes.content}>
                <EventBusyIcon
                    className={classes.icon}
                    style={{ color: iconColor }}
                />
                {/* Text Content */}
                <div>
                    <Typography
                        className={classes.title}
                        style={{ color: iconColor }}
                    >
                        {title}
                    </Typography>

                    <div>
                        <Typography>{description}</Typography>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NoDataFound;
